const axios = require('axios');

import { serverUrl } from '../properties'
const dataUrl = serverUrl;

export default {
    namespaced:true,
    state: {
        notificationList: [],
        notificationCount:0
    },
    mutations:{
        updateNotificationList: (state,list) => {
            state.notificationList = list
        },
        updateNotificationCount: (state,data) => {
            state.notificationCount = data
        }
    },
    getters: {
        receiveNotificationList:(state,getters)=>{
            return state.notificationList;
        },
        receiveNotificationCount:(state,getters)=>{
            return state.notificationCount;
        }
    },
    actions: {
        getNotificationList: ({ state, commit, rootGetters,rootState }, data) => {
			return new Promise((resolve, reject) => {
				commit('showLoadingSpinner', null, {root:true});
				let queryString = {
					entityId: rootGetters.getSearchFilterString.trim(),
					entity_type: rootGetters.getSelectedEntityTypeFilter,
					lastXDays: rootGetters.getSelectedLastXDays,
					vendor: rootGetters.getSelectedNotificationVendor,
                    // resultsPerPage: rootGetters.getShowPerPage,
                    resultsPerPage: sessionStorage.getItem("notification:showPerPage"),
                    pageNumber: rootGetters.getCurrentPageNumber,
                    sort: rootState.selectedSortOrder
					//orderBy: rootGetters.getSelectedSortOrder.order,
				}
				console.log(queryString)

				axios({
					url:  serverUrl + '/notification/list',
					method: 'POST',
					data: queryString,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					if (response) {
					//    payload.callback(response)
						resolve(response)
						if( response.data && response.data.data){
                            commit('updateNotificationList', response.data.data)
                            commit('updateNotificationCount', response.data.count)
						}
						commit('hideLoadingSpinner', null, { root:true })
					}
					resolve(response.data);
				}).catch((error) => {
					console.log(error)
					commit('hideLoadingSpinner', null, { root:true })
				})

			})

            // rp({
            //     uri: serverUrl + '/alerts',
            //     method:'GET',
            //     headers: {},
            //     qs: queryString,
            //     json:true
            // }).then((response) => {
            //     if (response) {
            //         payload.callback(response)
            //         commit('updateNotificationList', response)
            //         commit('hideLoadingSpinner', null, { root:true })
            //     }
            // }).catch((error) => {
            //     console.log(error)
            //     commit('hideLoadingSpinner', null, { root:true })
            // })
        },
    //     getNotificationList:({commit,state,rootGetters},data) => {
    //         return new Promise((resolve,reject) =>{
    //         commit('showLoadingSpinner',null,{root:true})
    //         axios({
    //             url: dataUrl + '/alert/get',
    //             method:'POST',
    //             headers :  rootGetters.fetchHeader,
    //             data:{},
    //             responseType: 'json'
    //         }).then(response => {
    //             resolve(response);
    //             commit('updateNotificationList', response.data)
    //             commit('hideLoadingSpinner',null,{root:true})
    //             commit('updateTotalCampaignAndProductCount',response.data.campaignTotalCount, {
    //                 root: true
    //             })
    //         }).catch((error) => {
    //             commit('hideLoadingSpinner',null,{root:true})
    //         })
	//
    //     })
    // },
    }
}
